// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-grid-Grid{
    -webkit-user-select: unset;
    -o-user-select: unset;
    user-select: unset;
}`, "",{"version":3,"sources":["webpack://./src/pages/Document/styles.css"],"names":[],"mappings":"AAAA;IACI,0BAA0B;IAG1B,qBAAqB;IACrB,kBAAkB;AACtB","sourcesContent":[".react-grid-Grid{\n    -webkit-user-select: unset;\n    -moz-user-select: unset;\n    -ms-user-select: unset;\n    -o-user-select: unset;\n    user-select: unset;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
